<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="700px" persistent>
    <v-card>
      <v-card-title>{{ formTitle }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-select
              v-model="local.auto_id"
              :items="autos"
              :item-title="autoLabel"
              item-value="id"
              label="Auto"
              :rules="[v => !!v || 'Requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="local.fecha_hora"
              type="datetime-local"
              label="Fecha y hora"
              :rules="[v => !!v || 'Requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="local.tipo_combustible_id"
              :items="tiposCombustible"
              item-title="descripcion"
              item-value="id"
              label="Tipo de combustible"
              :rules="[v => !!v || 'Requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="local.grifo_id"
              :items="grifos"
              item-title="descripcion"
              item-value="id"
              label="Grifo (opcional)"
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="local.kilometraje"
              type="number"
              min="0"
              label="Kilometraje"
              :rules="[v => v >= 0 || 'Inválido']"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="local.galones"
              type="number"
              step="0.001"
              min="0"
              label="Galones"
              :rules="[v => v > 0 || 'Inválido']"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="local.monto"
              type="number"
              step="0.01"
              min="0"
              label="Monto (S/)"
              :rules="[v => v >= 0 || 'Inválido']"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="local.descripcion"
              label="Descripción (opcional)"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="local.comprobante"
              label="Comprobante (opcional)"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancelar">Cancelar</v-btn>
        <v-btn color="primary" variant="flat" @click="guardar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    editedItem: { type: Object, default: () => ({}) },
    formTitle: String,
    autos: { type: Array, default: () => [] },
    tiposCombustible: { type: Array, default: () => [] },
    grifos: { type: Array, default: () => [] },
  },
  emits: ['update:dialog', 'save'],
  data() {
    return {
      local: this.buildLocal(this.editedItem),
    };
  },
  watch: {
    editedItem: {
      handler(n) {
        this.local = this.buildLocal(n);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    buildLocal(item) {
      const now = new Date();
      const tz = now.getTimezoneOffset() * 60000;
      const localDateTime = new Date(now - tz).toISOString().slice(0, 16);

      const base = {
        id: null,
        auto_id: null,
        fecha_hora: localDateTime,
        tipo_combustible_id: null,
        grifo_id: null,
        kilometraje: 0,
        galones: 0,
        monto: 0,
        descripcion: '',
        comprobante: '',
      };

      if (!item || !item.id) return base;

      return {
        id: item.id,
        auto_id: item.auto_id ?? null,
        fecha_hora: item.fecha_hora ? String(item.fecha_hora).slice(0, 16) : localDateTime,
        tipo_combustible_id: item.tipo_combustible_id ?? null,
        grifo_id: item.grifo_id ?? null,
        kilometraje: item.kilometraje ?? 0,
        galones: Number(item.galones ?? 0),
        monto: Number(item.monto ?? 0),
        descripcion: item.descripcion ?? '',
        comprobante: item.comprobante ?? '',
      };
    },
    autoLabel(a) {
      return `${a.placa} - ${a.marca} ${a.modelo}`;
    },
    cancelar() {
      this.$emit('update:dialog', false);
    },
    guardar() {
      const payload = {
        id: this.local.id,
        auto_id: this.local.auto_id,
        tipo_combustible_id: this.local.tipo_combustible_id,
        grifo_id: this.local.grifo_id,
        fecha_hora: this.local.fecha_hora.replace('T', ' ') + ':00',
        kilometraje: this.local.kilometraje,
        galones: this.local.galones,
        monto: this.local.monto,
        descripcion: this.local.descripcion || null,
        comprobante: this.local.comprobante || null,
      };
      this.$emit('save', payload);
    },
  },
};
</script>
